import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Link,
  IconButton,
  Tooltip,
  Box,
} from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';

export const CONTACT_SUPPORT_EMAIL = 'contacto@diactive.es';

const ContactSupportDialog = ({ open, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(CONTACT_SUPPORT_EMAIL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="contact-dialog-title">
      <DialogTitle id="contact-dialog-title">Contacta con nosotros</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          Envíanos un correo a:
        </DialogContentText>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
          <Link href={`mailto:${CONTACT_SUPPORT_EMAIL}`} underline="always" fontWeight={600}>
            {CONTACT_SUPPORT_EMAIL}
          </Link>
          <Tooltip title={copied ? '¡Copiado!' : 'Copiar'} placement="right">
            <IconButton size="small" onClick={handleCopy} aria-label="Copiar correo">
              {copied ? <Check fontSize="small" color="success" /> : <ContentCopy fontSize="small" />}
            </IconButton>
          </Tooltip>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="primary" variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactSupportDialog;
